:host {
  display: block;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: var(--aha-gray-600);
  border-top-left-radius: var(--Common--border-radius);
  border-top-right-radius: var(--Common--border-radius);

  --aha-carousel-navigation-button--width: 32px;
  --aha-carousel-navigation-button--height: 32px;
}

:host(:hover) #controls {
  opacity: 1;
}

:host #inner-container slot::slotted(*) {
  display: none;
  position: absolute;
  top: 0;
  transition: 0.2s ease-in-out left;
  width: 100%;
  height: 100%;
}

:host #inner-container slot::slotted(.next),
:host #inner-container slot::slotted(.prev),
:host #inner-container slot::slotted(.active) {
  display: flex;
}

:host #inner-container slot::slotted(.next) {
  left: 100%;
}

:host #inner-container slot::slotted(.prev) {
  left: -100%;
}

:host #inner-container slot::slotted(.slide) {
  left: 0;
}

:host #inner-container slot::slotted(.active) {
  left: 0;
}

:host #inner-container slot::slotted(.active.next) {
  left: -100%;
}

:host #inner-container slot::slotted(.active.prev) {
  left: 100%;
}

#controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  width: 100%;
  padding: 0 var(--spacer-2);
  box-sizing: border-box;
}

#controls button {
  cursor: pointer;
  border: 0;
  background: transparent;
}

#controls button .control-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--spacer-05);
  width: var(--aha-carousel-navigation-button--width);
  height: var(--aha-carousel-navigation-button--height);
  font-size: 12px;

  background: var(--theme-secondary-background);

  transition: opacity 0.2s linear;
  opacity: 0.4;
  &:hover {
    opacity: 0.6;
  }
  &:active {
    opacity: 0.8;
  }
}

#controls .control-arrow aha-icon {
  color: var(--theme-primary-text);
}
